import { motion } from "framer-motion";
import PageBanner from "@/components/public/PageBanner";
import Positioning from "@/components/landing/Positioning";
import Tour360 from "@/components/landing/Tour360";
import Estacionamento from "@/components/landing/Estacionamento";
import { useMedia } from "@/context/MediaContext";
import { resolveImg } from "@/lib/api";

export default function ShoppingPage() {
  const { banner_shopping, shopping_gallery } = useMedia();
  const gallery = (shopping_gallery || []).filter((g) => g && g.image);

  return (
    <>
      <PageBanner
        image={banner_shopping?.image}
        overline="O Shopping"
        title={banner_shopping?.title}
        subtitle={banner_shopping?.subtitle}
      />
      <Positioning />

      {gallery.length > 0 && (
        <section className="py-14 sm:py-20 px-5 sm:px-8 bg-vm-surface" data-testid="shopping-gallery-section">
          <div className="max-w-7xl mx-auto">
            <p className="text-xs tracking-[0.4em] uppercase text-vm-gold mb-6">Estrutura</p>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.05] mb-10" data-testid="shopping-gallery-title">
              Conheça nossos <span className="gold-text italic">espaços</span>
            </h2>
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
              {gallery.map((g, i) => (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 24 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: i * 0.08 }}
                  className="relative rounded-2xl overflow-hidden aspect-[3/4] group"
                  data-testid={`shopping-gallery-${i}`}
                >
                  <img src={resolveImg(g.image)} alt={g.label || "Estrutura do shopping"} className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
                  {g.label && <span className="absolute bottom-4 left-4 right-4 text-sm font-medium">{g.label}</span>}
                </motion.div>
              ))}
            </div>
          </div>
        </section>
      )}

      <Tour360 />
      <Estacionamento />
    </>
  );
}
